import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { EyeClosed, EyeIcon } from "lucide-react";
import * as React from "react";
import type { FieldValues } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { cn } from "@/lib/utils";
import { Button } from "./button";
import { type FormInputProps, Input, type InputProps } from "./input";
const PasswordInput = t0 => {
  const $ = _c(20);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const [showPassword, setShowPassword] = React.useState(false);
  const disabled = props.value === "" || props.value === undefined || props.disabled;
  let t1;
  if ($[3] !== className) {
    t1 = cn("hide-password-toggle", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShowPassword(_temp);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== disabled || $[7] !== showPassword) {
    t3 = showPassword && !disabled ? <EyeIcon aria-hidden="true" className="size-4" /> : <EyeClosed aria-hidden="true" className="size-4" />;
    $[6] = disabled;
    $[7] = showPassword;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = showPassword ? "Hide password" : "Show password";
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="sr-only">{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== disabled || $[12] !== t3 || $[13] !== t5) {
    t6 = <Button className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent" disabled={disabled} onClick={t2} size="sm" type="button" variant="ghost">{t3}{t5}</Button>;
    $[11] = disabled;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = showPassword ? "text" : "password";
  let t8;
  if ($[15] !== props || $[16] !== t1 || $[17] !== t6 || $[18] !== t7) {
    t8 = <Input className={t1} {...props} afterIcon={t6} type={t7} />;
    $[15] = props;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function FormPasswordInput(t0) {
  const $ = _c(16);
  let className;
  let description;
  let form;
  let inputProps;
  let label;
  let name;
  if ($[0] !== t0) {
    ({
      form,
      label,
      description,
      name,
      className,
      ...inputProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = form;
    $[4] = inputProps;
    $[5] = label;
    $[6] = name;
  } else {
    className = $[1];
    description = $[2];
    form = $[3];
    inputProps = $[4];
    label = $[5];
    name = $[6];
  }
  let t1;
  if ($[7] !== className || $[8] !== description || $[9] !== inputProps || $[10] !== label) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <FormItem className={cn(className)}>{label && <FormLabel>{label}</FormLabel>}<FormControl><PasswordInput {...inputProps} {...field} /></FormControl>{description && <FormDescription>{description}</FormDescription>}<FormMessage /></FormItem>;
    };
    $[7] = className;
    $[8] = description;
    $[9] = inputProps;
    $[10] = label;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== form.control || $[13] !== name || $[14] !== t1) {
    t2 = <FormField control={form.control} name={name} render={t1} />;
    $[12] = form.control;
    $[13] = name;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}
export { FormPasswordInput, PasswordInput };
function _temp(prev) {
  return !prev;
}